/* ==========================================================================
   SECTION : POURQUOI NOUS CHOISIR — carrousel mobile
   L'Atelier Banaat
   ========================================================================== */

document.addEventListener('DOMContentLoaded', initWhyUsCarousels);
document.addEventListener('shopify:section:load', initWhyUsCarousels);

function initWhyUsCarousels() {
  document.querySelectorAll('[data-why-us-carousel]').forEach((carousel) => {
    if (carousel.dataset.whyUsInitialized === 'true') return;
    carousel.dataset.whyUsInitialized = 'true';
    setupWhyUsCarousel(carousel);
  });
}

function setupWhyUsCarousel(carousel) {
  const slides = Array.from(carousel.querySelectorAll('.why-us__slide'));
  const total = slides.length;
  if (total === 0) return;

  let activeIndex = 0;
  let hideTimer;

  function mod(n) {
    return ((n % total) + total) % total;
  }

  function render() {
    slides.forEach((s, i) => {
      s.classList.remove('is-active', 'is-prev', 'is-next', 'is-hidden');
      if (total === 1) {
        s.classList.add('is-active');
        return;
      }
      if (i === activeIndex) s.classList.add('is-active');
      else if (i === mod(activeIndex - 1)) s.classList.add('is-prev');
      else if (i === mod(activeIndex + 1)) s.classList.add('is-next');
      else s.classList.add('is-hidden');
    });
  }

  function goTo(index) {
    activeIndex = mod(index);
    render();
  }

  function hideAllArrows() {
    slides.forEach((s) =>
      s.querySelectorAll('.why-us__arrow').forEach((a) => a.classList.remove('is-visible'))
    );
  }

  function showArrowsFor(slide) {
    hideAllArrows();
    slide.querySelectorAll('.why-us__arrow').forEach((a) => a.classList.add('is-visible'));
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideAllArrows, 2800);
  }

  // Indice visuel : la flèche "suivant" de la 1ère carte clignote légèrement au chargement
  const firstNextArrow = slides[0].querySelector('.why-us__arrow--next');
  if (firstNextArrow && total > 1) {
    firstNextArrow.classList.add('is-visible', 'is-hint');
  }

  function clearHint() {
    if (firstNextArrow) firstNextArrow.classList.remove('is-hint');
  }

  slides.forEach((slide) => {
    slide.addEventListener('click', (e) => {
      clearHint();
      if (e.target.closest('.why-us__arrow')) return; // géré séparément ci-dessous
      if (total === 1) return;
      if (slide.classList.contains('is-active')) {
        showArrowsFor(slide);
      } else if (slide.classList.contains('is-prev')) {
        goTo(activeIndex - 1);
      } else if (slide.classList.contains('is-next')) {
        goTo(activeIndex + 1);
      }
    });

    slide.querySelectorAll('.why-us__arrow').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        clearHint();
        clearTimeout(hideTimer);
        hideAllArrows();
        const dir = parseInt(btn.dataset.dir, 10);
        goTo(activeIndex + dir);
      });
    });
  });

  // Swipe tactile
  let touchStartX = 0;
  carousel.addEventListener(
    'touchstart',
    (e) => {
      clearHint();
      touchStartX = e.touches[0].clientX;
    },
    { passive: true }
  );

  carousel.addEventListener(
    'touchend',
    (e) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) {
        goTo(activeIndex + (dx < 0 ? 1 : -1));
      }
    },
    { passive: true }
  );

  render();
}